// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"14545754","239":"a333c686","453":"13994d8d","455":"d32b9348"}[chunkId] + ".chunk.js";
};